import { BarChart3, FolderOpen, Scale } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';

const MANAGEMENT_ICONS = {
  'Issues & Decisions': Scale,
  'Resources': FolderOpen,
  'Reports': BarChart3,
};

// Section 9 — issues, decisions, resources, reports. Editorial stepped rows,
// deliberately not another feature-card grid.
export const CompassManagement = ({ sp }) => (
  <section aria-labelledby="compass-management-heading" data-testid="compass-management" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        align="left"
        eyebrow="Wider Management"
        title="The details that keep management moving"
        description="Beyond plans and scorecards, Compass supports the wider management process — so context is never lost between meetings."
        testid="compass-management-header"
      />
      <ol className="mt-12 space-y-0">
        {(sp.management || []).map((item, i) => {
          const Icon = MANAGEMENT_ICONS[item.title] || Scale;
          return (
            <Reveal key={item.title} delay={i * 0.08}>
              <li className="relative flex gap-5 border-l-2 border-slate-200 pb-10 pl-8 last:pb-0" data-testid={`compass-management-${i + 1}`}>
                <span className="absolute -left-[1.35rem] top-0 flex h-10 w-10 items-center justify-center rounded-full border-2 border-gold-500 bg-white text-navy-900" aria-hidden="true">
                  <Icon className="h-4 w-4" />
                </span>
                <div>
                  <h3 className="text-lg font-extrabold tracking-tight text-navy-900">{item.title}</h3>
                  <p className="mt-1.5 max-w-xl text-sm leading-relaxed text-slate-600 sm:text-base">{item.text}</p>
                </div>
              </li>
            </Reveal>
          );
        })}
      </ol>
    </div>
  </section>
);
